import { Budget } from 'interfaces/Budget';
import { RepositoryParams, api } from '..';
import { BudgetTemplate } from 'interfaces/BudgetTemplate';

export type BudgetIncomeFilters = Partial<
  RepositoryParams & {
    budgetTemplate?: BudgetTemplate;
    budgetTemplateId?: string;
    budgetTemplateName?: string;
    costCenterId?: string;
  }
>;

export const list = async (params: BudgetIncomeFilters) => {
  return api.get('/budget-receitas', { params });
};

export const create = async (params: Budget) => {
  return api.post('/budget-receitas', { ...params });
};

export const update = async (params: Budget) => {
  return api.patch(`/budget-receitas/${params.id}`, { ...params });
};

export const retrieve = async (id: string) => {
  return api.get(`/budget-receitas/${id}`);
};

export const remove = async (id: string) => {
  return api.delete(`/budget-receitas/${id}`);
};
